import { type PointerEventHandler } from 'react'
type PlanAPreviewChevronProps = {
  onClick: () => void
  onPointerEnter?: PointerEventHandler<HTMLElement>
  onPointerLeave?: PointerEventHandler<HTMLElement>
}

// Large down-chevron pinned beneath the Plan A button, reading as an extension
// of it: a permanent "there's more below" cue that highlights the recommended
// plan. Clicking it does the same thing as clicking the button, and hovering it
// drives the same preview reveal. The darken + grow are keyed off the shared
// `group` wrapper in PrimaryButton2ChoicesFive, so hovering the button OR the
// chevron drives both — the two read as one target.
export const PlanAPreviewChevron = ({
  onClick,
  onPointerEnter,
  onPointerLeave,
}: PlanAPreviewChevronProps) => (
  <button
    type="button"
    aria-label="Preview Plan A"
    onClick={onClick}
    onPointerEnter={onPointerEnter}
    onPointerLeave={onPointerLeave}
    className="flex w-full cursor-pointer justify-center pt-2 text-black/55 transition-colors group-hover:text-black"
  >
    <svg
      width={64}
      height={36}
      viewBox="0 0 64 36"
      fill="currentColor"
      aria-hidden
      className="transition-transform group-hover:translate-y-1"
    >
      {/* Filled chevron with a sharp tip and flat top caps whose width matches
          the arm thickness at the midpoint of the upper segment (not wider). */}
      <polygon points="2,6 10,6 32,25 54,6 62,6 32,32" />
    </svg>
  </button>
)
